// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__gzN3K","title":"Menu_title__KmSkp","p":"Menu_p__UK6nf","loading":"Menu_loading__649iS"};